export default __webpack_public_path__ + "static/media/Statistic-2015-2016_SUB.3436318a.pdf";